/**
 * @generated SignedSource<<f054f0359affca8b0455e9fd73723d35>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthReason = "BAD_LEVEL" | "CREDENTIALS_REFUSED" | "INVALID_EMAIL" | "LINK_REFUSED" | "NAME_REQUIRED" | "NAME_TOO_LONG" | "NATIVE_LANGUAGE_IS_ENGLISH" | "PASSWORD_REFUSED" | "RESET_REQUESTED" | "SIGNUP_ACCEPTED" | "WEAK_PASSWORD" | "%future added value";
export type CefrLevel = "A1" | "A2" | "B1" | "B2" | "C1" | "C2" | "PRE_A1" | "%future added value";
export type SignUpInput = {
  cefrLevel: CefrLevel;
  displayLanguage?: string | null | undefined;
  displayName: string;
  email: string;
  nativeLanguage?: string | null | undefined;
  password: string;
};
export type SignupViewSignUpMutation$variables = {
  input: SignUpInput;
};
export type SignupViewSignUpMutation$data = {
  readonly signUp: {
    readonly ok: boolean;
    readonly reason: AuthReason | null | undefined;
  };
};
export type SignupViewSignUpMutation = {
  response: SignupViewSignUpMutation$data;
  variables: SignupViewSignUpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignUpPayload",
    "kind": "LinkedField",
    "name": "signUp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignupViewSignUpMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SignupViewSignUpMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "619989f252b4f4bd0d388d5c6eb92eb7",
    "id": null,
    "metadata": {},
    "name": "SignupViewSignUpMutation",
    "operationKind": "mutation",
    "text": "mutation SignupViewSignUpMutation(\n  $input: SignUpInput!\n) {\n  signUp(input: $input) {\n    ok\n    reason\n  }\n}\n"
  }
};
})();

(node as any).hash = "75fe0ea0b574a21e8fafae370e6d5356";

export default node;
